import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CacheProvider } from '@emotion/react';
import createEmotionRtlCache from './utils/rtlCache';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Ensure document is set to Arabic RTL globally
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', 'ar');
  document.documentElement.setAttribute('dir', 'rtl');
}

const cacheRtl = createEmotionRtlCache();
root.render(
  <React.StrictMode>
    <CacheProvider value={cacheRtl}>
      <App />
    </CacheProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
